import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const AirportDetail = lazy(() => import('./AirportDetail'))
const Exemptions = lazy(() => import('./Exemptions'))
const SafSupplies = lazy(() => import('./SafSupplies'))
const Divergences = lazy(() => import('./Divergences'))
const Config = lazy(() => import('./Config'))

export const RefuelEuRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--refuel-eu']}>
    <Route index element={<Index />} />
    <Route path='airports/:icao' element={<AirportDetail />} />
    <Route path='exemptions' element={<Exemptions />} />
    <Route path='saf' element={<SafSupplies />} />
    <Route path='divergences' element={<Divergences />} />
    <Route path='config/*' element={<Config />} />
  </SubRouter>
))
